export const isObjectEmpty = <T extends object>(
  obj: T | null | undefined
): boolean => {
  if (obj === null || obj === undefined) return true;
  return Object.keys(obj).length === 0;
};
